import './css/footer.css';

const Footer = () => (
    <div className="footer">
        <div className='social-icons'>
            <a href="https://discord.gg/wens" target="_blank" rel="noreferrer">
                <div className="icon icon-discord"></div>
            </a>
            <a href="https://twitter.com/theethwens" target="_blank" rel="noreferrer">
                <div className="icon icon-twitter"></div>
            </a>
            <a href="https://linktr.ee/ethwens" target="_blank" rel="noreferrer">
                <div className="icon icon-linktree"></div>
            </a>
        </div>
        <p>© Copyright 2022 by EthereumPoW Name Service</p>
    </div>
);

export default Footer;